export default {
  "event.header": "Events",
  "event.eventDate": "Event Date",
  "event.articleImage.pdf.link": "Click to open PDF",
  "event.openDate.title": "Date",
  "event.venue.title": "Venue",
  "event.eventPdf.title": "Event PDF",
  "event.articleLinkUrl.title": "(Opens an external site)",
  "event.entryDeadline.title": "Registration due date",
  "event.program.title": "Program",
  "event.speaker.title": "Speakers",
  "event.targetPerson.title": "Target",
  "event.admissionFee.title": "Participation Fee",
  "event.capacity.title": "Capacity",
  "event.organizers.title": "Organizer",
  "event.articleContact.title": "Contact",

  "event.footer.head1": "LINK-J's Latest",
  "event.footer.head2": "Event Information",
  "event.footer.body.newsletter": "Subscribe to LINK-J Event News",

  "event.list.title": "Events | LINK-J",
  "event.list.description":
    "In addition to information on LINK-J sponsored and co-sponsored events, the event listings provide information on events held by LINK-J special members (Special Member A, Special Member B) and others at facilities such as the Life Science Building Series.",
  "event.list.siteName": "LINK-J",
  "event.list.banner": "Events",
  "event.list.location.title": "Type：",
  "event.list.location.venuesAll": "All Events",
  "event.list.location.tokyoNihonbashi": "Nihonbashi, Tokyo​",
  "event.list.location.west": "Osaka, Kansai",
  "event.list.location.online": "Online",
  "event.list.category.label": "Category",
  "event.list.category.all": "All Events",
  "event.list.category.main": "LINK-J Events/LINK-J Supported Events",
  "event.list.category.coSponsorship": "Co-sponsorship",
  "event.list.category.memberEvent": "Special Member Events",
  "event.list.category.eventsMember": "Special Member Events",
  "event.list.category.attend": "Exhibitions",
  "event.list.category.archive": "Past Events",

  "event.list.pastEvents.filter.category": "Category",
  "event.list.pastEvents.filter.category.all": "ALL",
  "event.list.pastEvents.filter.category.main":
    "LINK-J Events/LINK-J Supported Events",
  "event.list.pastEvents.filter.category.coSponsorship": "Co-sponsorship",
  "event.list.pastEvents.filter.category.memberEvent": "Special Member Events",
  "event.list.pastEvents.filter.category.attend": "",
  "event.list.pastEvents.filter.location": "Type",
  "event.list.pastEvents.filter.location.all": "ALL",
  "event.list.pastEvents.filter.location.tokyoNihonbashi": "Nihonbashi, Tokyo",
  "event.list.pastEvents.filter.location.west": "Osaka, Kansai",
  "event.list.pastEvents.filter.location.online": "Online",
  "event.list.pastEvents.filter.year": "Year",
  "event.list.pastEvents.filter.year.all": "ALL",
  "event.list.pastEvents.filter.month": "Month",
  "event.list.pastEvents.filter.month.all": "ALL",
  "event.list.pastEvents.submit.label": "View more",

  "event.list.noMatchingEvents": "No matching events",
  "event.list.failedToRetrieveInformation": "Failed to retrieve information",

  // 特別会員開催イベント
  "event.memberEvent.header": "Special Member Events",
  "event.memberEvent.articleLinkText": "詳細・参加申込",

  // BBT
  "event.bbt.list.title": "",
  "event.bbt.list.title.suffix": "",
  "event.bbt.main.list.title.suffix": "",
  "event.bbt.specialMemberEvent.list.title.suffix": "",
  "event.bbt.list.title.suffix.bbt": "",
  "event.bbt.list.title.archive": "",
  "event.bbt.list.description": "",
  "event.bbt.list.banner": "",
  "event.bbt.list.category.all": "",
  "event.bbt.list.category.main": "",
  "event.bbt.list.category.collaboratedWithBbt": "",
  "event.bbt.list.category.supportedByBbt": "",
  "event.bbt.header": "",
} as const;
